import script from "./ChatsRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatsRadio.vue?vue&type=script&setup=true&lang=ts"

import "./ChatsRadio.vue?vue&type=style&index=0&id=2aede988&lang=scss&scoped=true"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aede988"]])

export default __exports__